jQuery(function($){
  var accordion = {
    init: function(){
      if ($('.link-row.m--accordion').length){
        accordion.initAccordion();
      }
    },
    initAccordion: function(){
      $('.link-row.m--accordion .link-row__info').off('click');
      $('.link-row.m--accordion .link-row__info').on('click', function(e) {
        e.preventDefault();
        $(this).parent('.link-row').toggleClass('deployed');
        $(this).parent('.link-row').siblings().removeClass('deployed');
        window.setTimeout(function(){
          if ($('.content-wall')){
            $('.content-wall').masonry();
          }
        }, 250);
      });
    }
  };
  window.accordion = accordion;
  $(document).ready(accordion.init);
});
